import React, { FC } from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import interactionPlugin from '@fullcalendar/interaction' //ユーザー操作に関するプラグイン
import { Events } from './types'
import { Popover } from 'antd'
import EventBlock from './EventBlock'
import { Spin, Title } from 'components/common'

export interface BookingsCalendarProps {
  eventSources: Events[]
}

const BookingsCalendar: FC<BookingsCalendarProps> = ({ eventSources }) => {
  // 週表示の時のヘッダーのフォーマット
  const dayHeaderFormat = (date) => {
    const day = date.date.day
    const weekNum = date.date.marker.getDay()

    // 週表示のヘッダー用の配列
    const week = ['(日)', '(月)', '(火)', '(水)', '(木)', '(金)', '(土)'][
      weekNum
    ]

    // 週表示の場合はヘッダーの文言を曜日のみにする（上記の配列参照）
    // それ以外の表示の時は「日 + ' ' + (曜日)」にする
    if (date.date.month !== 0) {
      return day + ' ' + week
    } else {
      return week
    }
  }

  if (!eventSources) return <Spin />

  return (
    <div>
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin]}
        initialView="dayGridMonth" //最初に表示されるカレンダータイプ
        editable={false} //イベントの編集に関するプロパティ。(trueだとドラッグ可能)
        nowIndicator={true} //週表示、日表示の時現在時刻を赤線で表示するかどうか
        businessHours={{
          daysOfWeek: [0, 1, 2, 3, 4, 5, 6], // 0:日曜 ~ 6:土曜
          startTime: '08:00',
          endTime: '22:00',
        }} //月曜から金曜、8:00~20:00を強調
        navLinks={true} //日付をクリックで日表示に遷移するかどうか
        selectable={true}
        allDaySlot={false}
        // slotMinTime="07:00:00" //最小表示時間の設定
        // slotMaxTime="23:00:00" //最大表示時間の設定
        weekends={true} //土日を表示するかどうか
        locale="ja" //表示言語の選択
        events={eventSources} //予定を配列で渡す
        // eventSources={eventSources} //複数の予定を渡す
        themeSystem="Materia"
        eventTimeFormat={{ hour: 'numeric', minute: '2-digit' }}
        eventDisplay={'block'}
        //カレンダーのヘッダーの設定
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right:
            'dayGridYear,dayGridMonth,timeGridWeek,timeGridDay,listMonth,listDay',
        }}
        // ボタンの設定
        buttonText={{
          prev: '<',
          next: '>',
          prevYear: '<<',
          nextYear: '>>',
          today: '今日',
          year: '年',
          month: '月',
          week: '週',
          day: '日',
          listMonth: '今月の予約',
          listDay: '今日の予約',
        }}
        // eventClick={handleEventClick}
        eventContent={renderEventContent}
        handleWindowResize={true}
        dayHeaderFormat={dayHeaderFormat}
        dayCellContent={(e) =>
          (e.dayNumberText = e.dayNumberText.replace('日', ''))
        }
        // contentHeight="auto"
      />
    </div>
  )
}
export default BookingsCalendar

// カレンダー上の棒のコンポーネント
const renderEventContent = (eventInfo) => {
  const event = eventInfo.event

  // イベントクリック時に表示されるポップに渡すイベント詳細のオブジェクト
  const eventDetails: Events = {
    title: event.title,
    productName: event.extendedProps.productName,
    start: event.start,
    end: event.end,
    purpose: event.extendedProps.purpose,
    numberOfPeople: event.extendedProps.numberOfPeople,
    color: event.backgroundColor,
  }

  // ポップのタイトル
  const title = (
    <div className="flex justify-start items-center gap-8">
      <div
        className={`w-7 h-7 rounded-lg border-slate-700 border-solid border`}
        style={{ backgroundColor: event.backgroundColor }}
      ></div>
      <div>
        <Title level={4} space="none">
          {event.title !== 'null' ? event.title : event.purpose}
        </Title>
      </div>
    </div>
  )

  // ポップのボディ（イベント詳細を表示）
  const content = (
    <>
      <EventBlock eventInfo={eventDetails} />
    </>
  )

  return (
    <>
      <Popover content={content} title={title} trigger="click">
        {/* カレンダー上に表示されるブロック */}
        <p className=" leading-tight mb-0 h-full">
          {event.extendedProps.productName}
          <br />
          {event.title !== 'null'
            ? event.title
            : event.extendedProps.purpose} |{' '}
          {event.extendedProps.numberOfPeople}人
        </p>
      </Popover>
    </>
  )
}
